import React from 'react'
import Footer from '../component/Footer'

const Turbosurgery = () => {
    return (
        <>
            <div className='heading'>
                <h1>Surgery for Turbo-Ovaries Masses </h1>
                <p>Home / Surgery for Turbo-Ovaries Masses</p>
            </div>

            <div className='desiese'>

                <div className='desiese1'>
                    <p><strong>Surgery for Tubo-Ovarian Masses:</strong></p>
                    <p>When dealing with tubo-ovarian masses, surgical intervention may be necessary for diagnosis and treatment. Here's an overview:</p>
                    <p><strong>Indications:</strong></p>
                    <ul>
                        <li><strong>Diagnostic Purposes:</strong> Surgery may be performed to obtain tissue samples for biopsy to determine the nature of the mass—whether it's benign (non-cancerous) or malignant (cancerous).</li>
                        <li><strong>Treatment:</strong> Surgery may also be necessary to remove the mass, especially if it's causing symptoms or if there's suspicion of cancer.</li>
                    </ul>
                    <p><strong>Procedure:</strong></p>
                    <p>During surgery for tubo-ovarian masses:</p>
                    <ol>
                        <li><strong>Preparation:</strong> The patient is prepared for surgery, which may involve fasting and preoperative tests to assess overall health.</li>
                        <li><strong>Incision:</strong> The surgeon makes an incision in the abdomen, often using minimally invasive techniques such as laparoscopy.</li>
                        <li><strong>Exploration:</strong> The abdominal cavity is carefully explored to locate the tubo-ovarian mass and assess its characteristics.</li>
                        <li><strong>Biopsy:</strong> If necessary, tissue samples are collected from the mass for biopsy to determine whether it's benign or malignant.</li>
                        <li><strong>Mass Removal:</strong> If the mass is deemed problematic or suspicious, the surgeon may proceed to remove it. This may involve removing the affected ovary and fallopian tube (salpingo-oophorectomy) or excising the mass while preserving the surrounding structures.</li>
                        <li><strong>Closure:</strong> Once the procedure is completed, the incisions are closed, and the patient is monitored during the postoperative period.</li>
                    </ol>

                </div>

            </div>

            <br />

            <Footer/>
        </>
    )
}

export default Turbosurgery